import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const wholesalers = async (data: WholesalersReqT) => {
  const { pageParam, name } = data;

  const qs = `?page=${pageParam ?? 1}&search=${name ?? ""}`;

  return axios.get(Routes.WHOLESALERS + qs);
};

export const useWholesalers = (params: WholesalersReqT) => {
  const { name } = params;

  return useInfiniteQuery({
    queryKey: [Keys.WHOLESALERS_QRY, name],
    queryFn: ({ pageParam = 1 }) => wholesalers({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage?.data?.links?.next
        ? lastPage?.data?.meta?.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
